import { ICurrencyActions, CurrencyContext } from './actions.types';
import { ICurrencyData } from '@/models';

export const actions: ICurrencyActions = {
  fetchCurrencies(context: CurrencyContext): Promise<void> {
    return this.$services.currency
      .fetchCurrencies()
      .then((currencies: ICurrencyData[]) => {
        context.commit('SET_CURRENCIES', currencies);
      });
  },

  fetchCurrency(context: CurrencyContext, payload: number): Promise<void> {
    return this.$services.currency
      .fetchCurrency(payload)
      .then((currency: ICurrencyData) => {
        const index = context.state.currencies.findIndex(
          (v: ICurrencyData) => v.id === currency.id
        );
        if (index === -1) {
          context.commit('ADD_CURRENCY', currency);
        } else {
          context.commit('UPDATE_CURRENCY', currency);
        }
      });
  },

  createCurrency(
    context: CurrencyContext,
    payload: ICurrencyData
  ): Promise<void> {
    return this.$services.currency
      .createCurrency(payload)
      .then((currency: ICurrencyData) =>
        context.commit('ADD_CURRENCY', currency)
      );
  },

  updateCurrency(
    context: CurrencyContext,
    payload: ICurrencyData
  ): Promise<void> {
    return this.$services.currency
      .updateCurrency(payload)
      .then((currency: ICurrencyData) => {
        const index = context.state.currencies.findIndex(
          (v: ICurrencyData) => v.id === currency.id
        );
        if (index === -1) {
          context.commit('ADD_CURRENCY', currency);
        } else {
          context.commit('UPDATE_CURRENCY', currency);
        }
      });
  },

  deleteCurrency(context: CurrencyContext, payload: number): Promise<void> {
    return this.$services.currency.deleteCurrency(payload).then(() => {
      context.commit('REMOVE_CURRENCY', payload);
    });
  }
};
